import React, { useState } from 'react';
import { Alert, Button, Modal, Tag } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import './QuitPassword.scss';
import { useTranslate } from 'lib/MrTranslate/MrTranslate';

const QuitPassword = (props) => {
  const { experience } = props
  console.log("QuitPassword props ==>", experience);
  const mrIntl = useTranslate();
  // State hook to manage the visibility of the modal
  const [showModal, setShowModal] = useState(false);

  // Extracting nested properties from the 'experience' object
  const experienceSettings = experience.settings || {};
  const lockdownConfig = experienceSettings.lockdown_config || {};
  const quitPassword = lockdownConfig.quit_password || "";

  return (
    <>
      {/* Button to trigger the display of the quit password modal */}
      <Button
        className='seb-quit-password-button'
        icon={<LockOutlined />}
        type='text'
        onClick={() => {
          setShowModal(true)
        }}
      >
        {mrIntl("QuitPassword.seb_quit_password")}
      </Button>
      {/* Modal to display the quit password and related information */}
      <Modal
        className='seb-password-modal'
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={null}
      >
        <Alert
          className='seb-password-alert'
          message={mrIntl("QuitPassword.seb_quit_password")}
          type="info"
          showIcon
        />
        <div className='seb-password-div'>
          <Tag className='seb-password-tag'>{quitPassword}</Tag>
        </div>
        <br />
        <p>{mrIntl("QuitPassword.this_password_is_required_if_a_student_attempts_to_switch")}</p>
        <Alert
          className='seb-password-warning'
          message={<span><b>{mrIntl("QuitPassword.important")}</b>: {mrIntl("QuitPassword.do_not_reveal_this_password_to_students")}</span>}
          type="warning"
          showIcon
        />
      </Modal>
    </>
  );
};

export default QuitPassword;


